/* ================================================== */
/* LINKS → Scroll down
/* ================================================== */

$(document).ready(function() {

	// Scroll to top on click
	$('.scroll-down').click(function(event) {
		event.preventDefault();

		var page = $('html, body');

		// Stop auto-scroll if user scroll
		page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function() {
			page.stop()
		});

		// Auto-scroll
		page.animate({ scrollTop: $(document).height() }, 600);
	});

});